import { Button, Input, Modal } from "antd";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import "../SubadminForms.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Error, Success } from "../../../commons/Messages/Messages";

import { useTranslation } from "react-i18next";
const UpdateDepartment = ({ updateParent, data }) => {
  const { t } = useTranslation("dashboard");
  const [formData, setFormData] = useState({
    title: ""
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (key, val) => {
    setFormData({
      ...formData,
      [key]: val
    });
  };

  const onSubmit = async e => {
    e.preventDefault();
    await axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/departments/update/${data?._id}`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  useEffect(() => {
    setFormData({
      title: data?.title
    });

    return () => {};
  }, [data]);

  return (
    <div className="subadmin-form">
      <MainButtonComp text="Update" editBtn onClick={showModal} />
      <Modal
        destroyOnClose
        title={t("Update Department")}
        width={520}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="save" type="primary" htmlType="submit" form="subadmin-update-department">
            {t("Save")}
          </Button>
        ]}
      >
        <form id="subadmin-update-department" className="subadmin-form__body" onSubmit={onSubmit}>
          <div className="subadmin-form__field">
            <label htmlFor="subadmin-update-department-title">{t("Department Title")}</label>
            <Input
              id="subadmin-update-department-title"
              value={formData.title}
              onChange={e => handleChange("title", e.target.value)}
              autoComplete="off"
            />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default UpdateDepartment;
